import Modal from "./modal";

export default function dashboardController() {
    $(document.body).on('click', '.tourist_card_alt', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const model = new Modal({
            body: '<h1 class="green">Card Payment Unavailable</h1><p class="mb-2">Pay Now is not available at the moment, we will ask you to pay later.</p><p class="mb-2">It will take 14-21 business days to deliver your Card.</p>',
            fnContinue: () => {
                $('#touristCardAlt').submit();
            },
            backButtonState: 'disabled',
            closeButtonState: 'disabled',
            continueButtonText: 'Continue'
        });
    });

    $(document.body).on('click', '.tourist_topup_alt', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const model = new Modal({
            body: '<h1 class="green">Card Top Up Unavailable</h1><p class="mb-2">This Service is not available at this time.</p><p class="mb-2">Please visit your nearest EmbassyCard Merchant or Load your Card using the EmbassyCard App.</p>',
            fnContinue: () => {
                model.close();
            },
            backButtonState: 'disabled',
            closeButtonState: 'disabled',
            continueButtonText: 'Continue'
        });
    });
}